const userRequestStatuses = Object.freeze({
    Nueva: 0,//este no es un estatus como tal, es el estado en que se encuantra al no tener status previo 
    Sometida: 1,

  Aprobada: 2,
  Cancelada: 3,
  Denegada: 4,
})

export default userRequestStatuses
